import Icon from '../components/Icon.vue'

Icon.register({
  'exclamation-circle': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M504 256C504 393 393 504 256 504S8 393 8 256C8 119.1 119 8 256 8S504 119.1 504 256zM256 306C230.6 306 210 326.6 210 352S230.6 398 256 398 302 377.4 302 352 281.4 306 256 306zM212.3 140.7L219.7 276.7C220.1 283 225.4 288 231.7 288H280.3C286.6 288 291.9 283 292.3 276.7L299.7 140.7C300 133.8 294.6 128 287.7 128H224.3C217.4 128 212 133.8 212.3 140.7z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/exclamation-circle.js
// module id = 7DwN
// module chunks = 144